<template lang="pug">
  div.app.flex-row.align-items-center(style='background: white;')
    div.container
      div.row.justify-content-center
        | Logging Out
</template>

<script>
import { auth } from '@/firebase'

export default {
  name: 'Logout',
  data() {
    return {
    }
  },
  mounted: function() {
    auth.signOut().then(() => {
      this.$router.replace('login')
      this.$snotify.info('You have successfully logged out')
    })
  },
}
</script>



// WEBPACK FOOTER //
// src/views/Logout.vue?30ca76ab